// The reviewer's view of the job's own prices (#413 decision 3: "clearly
// highlighted for the reviewer", as STM002 did), shown above the REVIEW
// checklist: the option's job-priced and one-off paints, and the job's hire
// and material prices. Nothing shows when the quote uses book prices only.
import { JOB_PRICE_KIND, priceTag, type JobPrice, type PricingRates } from '@higgins/m2q-pricing';
import { formatMoney } from './surface-format';

/** One job hire or material row as the reviewer reads it. */
function rowText(p: JobPrice): string {
  if (p.kind === JOB_PRICE_KIND.material) return `${p.name} (job material): ${formatMoney(p.rate ?? 0)} each`;
  const rates = [p.dayRate !== null && `${formatMoney(p.dayRate)}/day`, p.transport !== null && `${formatMoney(p.transport)} cartage`].filter(Boolean).join(', ');
  const against = p.hireItemId && p.bookPrice !== null ? ` against the list's ${formatMoney(p.bookPrice)}/day` : '';
  return `${p.name} (${p.hireItemId ? 'job price' : 'quoted for this job'}${p.diesel ? ', diesel' : ''}): ${rates}${against}`;
}

export function JobPricesNotice({ rates, prices }: { rates: PricingRates; prices: readonly JobPrice[] }) {
  const paints = rates.paints.filter((p) => priceTag(p));
  // Only rows with a price in force: a cleared hire or material row is no job price.
  const others = prices.filter((p) => p.kind !== JOB_PRICE_KIND.paint && (p.dayRate !== null || p.transport !== null || p.rate !== null));
  if (!paints.length && !others.length) return null;
  return (
    <div className="mb-3 rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
      <p className="font-medium">Prices typed for this job — check them:</p>
      <ul className="mt-1 list-disc pl-5">
        {paints.map((p) => (
          <li key={p.id}>
            {p.name} ({priceTag(p)}): {formatMoney(p.costPerLitre)}/L
            {typeof p.bookCostPerLitre === 'number' && <> against the book&rsquo;s {formatMoney(p.bookCostPerLitre)}/L</>}
          </li>
        ))}
        {others.map((p) => (
          <li key={p.id}>{rowText(p)}</li>
        ))}
      </ul>
    </div>
  );
}
